import { Grid, Card, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";
import { useMaterialUIController, setWithdrawalContext } from "context";
import configurationContext from "contextConfig";
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';
import configurations from "config";
import { WITHDRAWAL } from 'constants';

function ManageWithdrawals() {
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { withdrawalContext } = controller;
  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }
  const { t } = useTranslation();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [withdrawalData, setData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const searchFilterData = { 'statusFilter': withdrawalContext.statusFilter, "orderBy": withdrawalContext.orderBy, "orderValue": withdrawalContext.orderValue };
  const [isLoading, setIsLoading] = useState(true);
  const [isWithdrawalContextChanged, setWithdrawalContextChanged] = useState(false);

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: baseUrl + "/withdrawal/list",
      method: "POST",
      data: { ...searchFilterData, pageSelected: pageSelected },
      headers: {
        Authorization: bearerToken,
        function: azureFunctionVendorFrontendKey
      }
    }).then(function (response) {
      setIsLoading(false);
      const message = response.data.message;
      response.status == 200 ?
        (
          response.data.status == 1 ?
            (setData(response.data),
              (response.data && response.data.data && response.data.data.totalCount) ?
                setResponseResultCount(response.data.data.totalCount)
                :
                null)
            :
            toast.error(t(message))
        )
        :
        toast.error(t('unableToProccessRequest'));
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const handleResetFilters = () => {
    setWithdrawalContext(dispatch, initialState.withdrawalContext);
    setWithdrawalContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/withdrawal/list/page-1");
    else
      navigate("/withdrawal/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(withdrawalContext).some(
      key => withdrawalContext[key] !== initialState.withdrawalContext[key]
    );
    setWithdrawalContextChanged(hasChanged);
  }, [withdrawalContext]);

  const columns = [
    { Header: t('Id'), accessor: "id", align: "left" },
    { Header: t("Order Id"), accessor: "vendorOrderId", align: "left" },
    { Header: t("Total Price"), accessor: "totalPrice", align: "left" },
    { Header: t("Admin Charges"), accessor: "adminCommission", align: "right" },
    { Header: t("Vendor Due"), accessor: "vendorAmount", align: "right" },
    { Header: t("Discount"), accessor: "totalDiscount", align: "right" },
    { Header: t("Shipping Cost"), accessor: "shippingCost", align: "right" },
    { Header: t("Return Cost"), accessor: "returnCost", align: "right" },
    { Header: t("Status"), accessor: "status", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];
  const finalObj = [];
  if (withdrawalData.data && withdrawalData.data.rows) {
    let withdrawalRecords = withdrawalData.data.rows;
    for (const rowKey in withdrawalData.data.rows) {
      let withdrawalRecord = withdrawalRecords[rowKey];
      if (withdrawalRecord.id > 0) {
        let tempObj = {
          id:
            <MDTypography component="a"
              href={"#"}
              onClick={(event) => { event.preventDefault(); navigate("/withdrawal/view/" + withdrawalRecord.id) }}
              variant="caption" color="text" fontWeight="medium">
              {'#' + withdrawalRecord.id}
            </MDTypography>,
          vendorOrderId: withdrawalRecord.vendorOrderId,
          totalPrice: withdrawalRecord.totalPrice,
          adminCommission: withdrawalRecord.adminCommission,
          vendorAmount: withdrawalRecord.vendorAmount,
          totalDiscount: withdrawalRecord.totalDiscount,
          shippingCost: withdrawalRecord.shippingCost,
          returnCost: withdrawalRecord.returnCost,
          status: <span className={'statusD' + withdrawalRecord.status}>
            {
              (withdrawalRecord.status == WITHDRAWAL.COMPLETED) ? <span>{t('Completed')}</span> :
                (withdrawalRecord.status == WITHDRAWAL.PENDING) ? <span>{t('Pending')}</span> : null}</span>,
          action:
            <Link href={"#"}
              onClick={(event) => { event.preventDefault(); navigate("/withdrawal/view/" + withdrawalRecord.id) }}
            >
              <Box className="squareBoxView"><VisibilityIcon color="primary" fontSize="medium" titleAccess={t("View")} /></Box></Link>
        };
        finalObj.push(tempObj);
      }
    }
  }
  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("withdrawalRequests")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      {(Object.keys(withdrawalData).length > 0) ?
        <MDBox pt={6} pb={3} className="ContentSectionBox">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                  <Grid container className="FilterSectionBox" spacing={2} >
                    <Grid item xs={12} sm={2} md={2} >
                      <MDInput
                        select
                        name="statusFilter"
                        label={t('status')}
                        value={searchFilterData.statusFilter}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        className="ManageProductTopSecip"
                        onChange={(obj) => {
                          setWithdrawalContext(dispatch, { ...withdrawalContext, statusFilter: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'all'}>{t('all')}</MenuItem>
                        <MenuItem value={1}>{t('Completed')}</MenuItem>
                        <MenuItem value={2}>{t('Pending')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="orderBy"
                        value={searchFilterData.orderBy}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        label={t('orderBy')}
                        onChange={(obj) => {
                          setWithdrawalContext(dispatch, { ...withdrawalContext, orderBy: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'id'}>{t('Id')}</MenuItem>
                        <MenuItem value={'createdAt'}>{t('Created At')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={1} md={1}>
                      <MDInput
                        select
                        name="orderValue"
                        value={searchFilterData.orderValue}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        label={t('order')}
                        onChange={(obj) => {
                          setWithdrawalContext(dispatch, { ...withdrawalContext, orderValue: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                        <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={1} md={1}>
                      <FormControl className="filterSubmit">
                        <MDButton
                          onClick={() => {
                            navigate("/withdrawal/list");
                            if (typeof pageNo === "undefined")
                              data();
                          }}
                          key="submit" type="submit" color="info" size="small" disableRipple fullWidth>{t('submit')}</MDButton>
                        {isWithdrawalContextChanged && (
                          <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    showTotalEntries={true}
                    responseResultCount={responseResultCount}
                    paginationSize={MyContext.paginationSize}
                    paginationLink={"/withdrawal/list/page-"}
                    pageSelected={pageSelected}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageWithdrawals;
